// グロナビ固定
if (document.querySelector('#aceessRoot') !== null) {
  const startPointBtns = document.querySelectorAll('.access-root__btn-start');
  const startPointBtnsClass = document.getElementsByClassName('access-root__btn-start');
  let startPoint = '';

  startPointBtns.forEach(function (target) {
    target.addEventListener('click', function () {
      if (target.classList.contains('is-active')) {
        target.classList.remove('is-active');
      } else {
        for (let i = 0; i < startPointBtnsClass.length; i++) {
          startPointBtnsClass[i].classList.remove('is-active');
        }
        target.classList.add('is-active');
        startPoint = target.value;
      }
    });
  });

  const accessInputStart = document.getElementById('accessInputStart');

  accessInputStart.addEventListener('input', function () {
    for (let i = 0; i < startPointBtnsClass.length; i++) {
      startPointBtnsClass[i].classList.remove('is-active');
      startPoint = '';
    }
  });

  accessInputStart.addEventListener('change', function () {
    if (accessInputStart.value !== '') {
      startPoint = accessInputStart.value;
    }
  });

  const endPointBtns = document.querySelectorAll('.access-root__btn-end');
  const endPointBtnsClass = document.getElementsByClassName('access-root__btn-end');
  let endPoint = '';

  endPointBtns.forEach(function (target) {
    target.addEventListener('click', function () {
      if (target.classList.contains('is-active')) {
        target.classList.remove('is-active');
      } else {
        for (let i = 0; i < endPointBtnsClass.length; i++) {
          endPointBtnsClass[i].classList.remove('is-active');
        }
        target.classList.add('is-active');
        endPoint = target.value;
      }
    });
  });

  const accessInputEnd = document.getElementById('accessInputEnd');

  accessInputEnd.addEventListener('input', function () {
    for (let i = 0; i < endPointBtnsClass.length; i++) {
      endPointBtnsClass[i].classList.remove('is-active');
      endPoint = '';
    }
  });

  accessInputEnd.addEventListener('change', function () {
    if (accessInputEnd.value !== '') {
      endPoint = accessInputEnd.value;
    }
  });

  const accessRootBtn = document.getElementById('accessRootBtn');

  accessRootBtn.addEventListener('click', function () {
    const language = document.documentElement.lang;
    const url = 'https://www.google.co.jp/maps/dir/' + startPoint + '/' + endPoint + '?hl=' + language;
    accessRootBtn.setAttribute('target', '_blank'); // target属性を設定
    accessRootBtn.setAttribute('href', url); // href属性を設定
  });
}
